"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitPunchCTK = exports.useSubmitPunchNonCTK = exports.useSubmitMissedPunchV2 = exports.useSubmitPunch = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const DateManagement_1 = require("../../utils/DateManagement");
const eventEmitter_1 = require("../../utils/EventEmitter/eventEmitter");
const taaEvents_1 = require("../../utils/EventEmitter/taaEvents");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
function useSubmitPunch(props) {
    const submitCTKData = useSubmitPunchCTK(props.ctkPolicy, props.usageLocation);
    const submitNonCTKData = useSubmitPunchNonCTK(props);
    const submitMissedPunchV2Data = useSubmitMissedPunchV2(props);
    return props.ctkPolicy
        ? submitCTKData
        : props.useV2Api
            ? submitMissedPunchV2Data
            : submitNonCTKData;
}
exports.useSubmitPunch = useSubmitPunch;
function useSubmitMissedPunchV2(props) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    if (props.ctkPolicy) {
        return undefined;
    }
    const submitPunch = (punchTime, punchDate, useMilitaryTime, isHistorical = false) => {
        setRetryParams(undefined);
        setData('');
        const punchDateTime = (0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO();
        mutate({
            path: (0, paths_1.SUBMIT_MISSED_PUNCH_V2_API)(props.employeeId || ''),
            method: 'POST',
            body: {
                employeeId: props.employeeId || '',
                siteId: props.siteId || '',
                punchDateTime: {
                    timestamp: punchDateTime,
                    timezone: props.timeZone
                },
                isHistorical
            },
            metaData: {
                apiName: 'submitMissedPunchV2',
                clientName
            },
            usageLocation: props.usageLocation
        }, {
            onSuccess: () => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_MISSED_PUNCH, { responseCode: 200 });
                logger_1.logger.emitCountMetric({
                    metricName: isHistorical
                        ? logger_1.METRICS.MISSED_PUNCH_REQUEST_HISTORICAL_SUCCESS.COUNT
                        : logger_1.METRICS.MISSED_PUNCH_REQUEST_NON_HISTORICAL_SUCCESS.COUNT,
                    dimensions
                });
                setData(punchDateTime);
            },
            onError: (error) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_MISSED_PUNCH, {
                    data: error,
                    responseCode: error.statusCode || 500
                });
                logger_1.logger.emitCountMetric({
                    metricName: isHistorical
                        ? logger_1.METRICS.MISSED_PUNCH_REQUEST_HISTORICAL_ERROR.COUNT
                        : logger_1.METRICS.MISSED_PUNCH_REQUEST_NON_HISTORICAL_ERROR.COUNT,
                    dimensions
                });
                setRetryParams({
                    punchTime,
                    punchDate,
                    useMilitaryTime,
                    isHistorical
                });
            }
        });
    };
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { punchTime, punchDate, useMilitaryTime, isHistorical } = retryParams;
        submitPunch(punchTime, punchDate, useMilitaryTime, isHistorical);
    };
    return {
        submitPunchState: {
            data,
            loading,
            error: retryParams ? error : undefined,
            retry
        },
        submitPunch
    };
}
exports.useSubmitMissedPunchV2 = useSubmitMissedPunchV2;
function useSubmitPunchNonCTK({ employeeId, siteId, timeZone, ctkPolicy, usageLocation }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    if (ctkPolicy) {
        return undefined;
    }
    const submitPunch = (punchTime, punchDate, useMilitaryTime) => {
        setRetryParams(undefined);
        setData('');
        const punchDateTime = (0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO();
        mutate({
            path: (0, paths_1.SUBMIT_PUNCH_API)(employeeId || ''),
            method: 'POST',
            body: {
                isMissedPunchCorrection: true,
                isPunchValidationRequired: true,
                location: siteId || '',
                userTimeZone: timeZone || '',
                punchDateTime
            },
            metaData: {
                apiName: 'submitPunchNonCTK',
                clientName
            },
            usageLocation
        }, {
            onSuccess: () => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, { responseCode: 200 });
                setData(punchDateTime);
            },
            onError: (error) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, {
                    data: error,
                    responseCode: error.statusCode || 500
                });
                setRetryParams({
                    punchTime,
                    punchDate,
                    useMilitaryTime
                });
            }
        });
    };
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { punchTime, punchDate, useMilitaryTime } = retryParams;
        submitPunch(punchTime, punchDate, useMilitaryTime);
    };
    return {
        submitPunchState: {
            data,
            loading,
            error: retryParams ? error : undefined,
            retry
        },
        submitPunch
    };
}
exports.useSubmitPunchNonCTK = useSubmitPunchNonCTK;
function useSubmitPunchCTK(ctkPolicy, usageLocation) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.postESSData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    if (!ctkPolicy) {
        return undefined;
    }
    const submitPunch = (punchTime, punchDate, useMilitaryTime) => __awaiter(this, void 0, void 0, function* () {
        setRetryParams(undefined);
        setData('');
        const ctkTime = useMilitaryTime
            ? punchTime
            : (0, DateManagement_1.convertTimeStringToMilitaryTimeString)(punchTime);
        const punchDateString = punchDate.toJSDate().toDateString();
        mutate({
            path: (0, paths_1.SUBMIT_PUNCH_CTK_API)(),
            method: 'POST',
            body: {
                missed_punch_ticket: {
                    date: punchDateString,
                    missed_punches: [ctkTime]
                }
            },
            metaData: {
                apiName: 'submitPunchCTK',
                clientName
            },
            usageLocation
        }, {
            onSuccess: () => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, { responseCode: 200 });
                setData((0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO());
            },
            onError: (err) => {
                eventEmitter_1.Emitter.emit(taaEvents_1.taaEvents.SUBMIT_PUNCH, {
                    data: err,
                    responseCode: err.statusCode || 500
                });
                setRetryParams({
                    punchTime,
                    punchDate,
                    useMilitaryTime
                });
            }
        });
    });
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { punchTime, punchDate, useMilitaryTime } = retryParams;
        submitPunch(punchTime, punchDate, useMilitaryTime);
    };
    return {
        submitPunchState: {
            data,
            loading,
            error: retryParams ? error : undefined,
            retry
        },
        submitPunch
    };
}
exports.useSubmitPunchCTK = useSubmitPunchCTK;
